import { useFragment } from '@apollo/client/react';
import { isEmpty } from 'lodash';

import { createRequiredContext } from 'src/context/createRequiredContext';
import { EscrowPartyTypeEnum, type IEscrowInvitation } from 'src/graphql/schema';
import { EscrowInvitationFields } from 'src/graphql/actions/escrow/escrowInvitation.fragment';

const [useEscrowInvitationContext, EscrowInvitationProvider] = createRequiredContext<{
  escrowId: string;
  escrowInvitation: IEscrowInvitation | null;
  invitePartyType: EscrowPartyTypeEnum;
  canInviteParty: boolean;
}>();

type Props = {
  escrowId: string;
  invitationId: string | null;
  invitePartyType: EscrowPartyTypeEnum;
  canInviteParty: boolean;
};

const EscrowInvitationContextProvider = ({
  escrowId,
  invitationId,
  invitePartyType,
  canInviteParty,
  children,
}: React.PropsWithChildren<Props>) => {
  const { data, complete } = useFragment<IEscrowInvitation>({
    fragment: EscrowInvitationFields,
    from: {
      __typename: 'EscrowInvitation',
      id: invitationId || '',
    },
  });

  const value = {
    escrowId,
    escrowInvitation: complete && !isEmpty(data) && invitationId ? data : null,
    invitePartyType,
    canInviteParty,
  };

  return <EscrowInvitationProvider value={value}>{children}</EscrowInvitationProvider>;
};

export { useEscrowInvitationContext, EscrowInvitationContextProvider };
